// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import 'vant/lib/index.css'
import axios from './axios'
import store from "./store"
import Cookie from "js-cookie"
// import VConsole from 'vconsole'//移动端调试
import wx from 'weixin-js-sdk';
import "./assets/css/iconfont.css";
import { DatetimePicker } from 'vant';
import { Loading } from 'vant';
import { ImagePreview } from 'vant';


Vue.config.productionTip = false
// const vConsole = new VConsole() //注意
Vue.prototype.$axios = axios
Vue.prototype.$wx = wx
Vue.use(Vant)
Vue.use(DatetimePicker);
Vue.use(Loading);
Vue.use(ImagePreview);

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
Vue.config.productionTip = false;
// export default vConsole
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    store,
    Cookie
})




// WEBPACK FOOTER //
// ./src/main.js